import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-platform-games',
  templateUrl: './platform-games.component.html',
  styleUrls: ['./platform-games.component.scss']
})
export class PlatformGamesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
